

export enum ProductSize{
    SMALL_20 ="20 INCH",
    LARGE = "28 INCH",
}

export enum ProductBundle{
    SINGLE="SINGLE",
    SET="SET",
}


export enum ProductColor{
    GREY="GREY",
    WHITE="WHITE",
    PINK="PINK",

    DARK_BROWN="DARK_BROWN",
    GOLD="GOLD",
    BURGUNDY="BURGUNDY",
}

export enum ProductStatus {
    PAUSE = "PAUSE",
    PROCESS = "PROCESS",
    DELETE = "DELETE",
}

export enum ProductCollection{
    TRAVEL="TRAVEL",
    SPORT="SPORT",
    BUSINESS="BUSINESS",
    SPECIAL="SPECIAL",
     
}

export enum ProductMode {
    ELEGANT="ELEGANT",
    PREMIUM="PREMIUM",
    
}